import {flashcard} from './Flashcard';
import {imageToImage} from './ImageToImage';

export const otherFeatures = {
  flashcard,
  imageToImage,
};
